/**
 * keyboardShortcutsStore — global Cmd+/ overlay state.
 *
 * Owns a single boolean ``isOpen`` plus open/close/toggle. Same minimal
 * shape as ``userMenuStore`` and ``studioStore`` so any callsite can
 * pop the overlay imperatively without threading a callback through the
 * tree (the avatar drawer + the global ⌘/ / ? listener both call
 * ``open()``).
 *
 * No mutex against other drawers — the overlay is a Radix Dialog with
 * its own focus-trap, so it stacks cleanly on top of avatar / studio.
 * ESC closes via Radix's built-in handler.
 */

import { create } from "zustand";

interface KeyboardShortcutsState {
  isOpen: boolean;
  open: () => void;
  close: () => void;
  toggle: () => void;
}

export const useKeyboardShortcutsOverlay = create<KeyboardShortcutsState>()(
  (set, get) => ({
    isOpen: false,
    open: () => set({ isOpen: true }),
    close: () => set({ isOpen: false }),
    toggle: () => set({ isOpen: !get().isOpen }),
  }),
);
